import { CartItem } from '@/types/cart';
import { useAnalytics } from './useAnalytics';

export const useCartTracking = () => {
  const { trackAddToCart, trackRemoveFromCart, trackViewCart } = useAnalytics();

  const trackAddToCartEvent = (product: CartItem) => {
    trackAddToCart({
      currency: 'EUR',
      value: product.price * (product.quantity || 1),
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          item_category: product.category,
          item_category2: product.category2,
          item_category3: product.category3,
          item_brand: product.brand,
          item_variant: product.variant,
          price: product.price,
          quantity: product.quantity || 1,
          currency: 'EUR',
          bar_code: product.barcode,
        },
      ],
    });
  };

  const trackRemoveFromCartEvent = (product: CartItem) => {
    trackRemoveFromCart({
      currency: 'EUR',
      value: product.price * (product.quantity || 1),
      items: [
        {
          item_id: product.id,
          item_name: product.name,
          item_category: product.category,
          item_category2: product.category2,
          item_category3: product.category3,
          item_brand: product.brand,
          item_variant: product.variant,
          price: product.price,
          quantity: product.quantity || 1,
          currency: 'EUR',
          bar_code: product.barcode,
        },
      ],
    });
  };

  const trackViewCartEvent = (cartItems: CartItem[]) => {
    const totalValue = cartItems.reduce((total, item) => total + item.price * item.quantity, 0);

    trackViewCart({
      currency: 'EUR',
      value: totalValue,
      items: cartItems.map((item) => ({
        item_id: item.id,
        item_name: item.name,
        item_category: item.category,
        item_category2: item.category2,
        item_category3: item.category3,
        item_brand: item.brand,
        item_variant: item.variant,
        price: item.price,
        quantity: item.quantity,
        currency: 'EUR',
        bar_code: item.barcode,
      })),
    });
  };

  return {
    trackAddToCartEvent,
    trackRemoveFromCartEvent,
    trackViewCartEvent,
  };
};
